// extracted by mini-css-extract-plugin
export default {"root":"TipSecondClickContent__root--1I7TN"};